// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__8qrwo","alertIcon":"ConfirmModal_alertIcon__1y69Q"};